const blankCSS = ``;

export default blankCSS;
